import React, { Component } from 'react'
import DriveFrame from '../../components/header/DriveViewType'
import DriveView from './DriveStyle'
import DriveSort from './DriveSort'
import DriveNew from './DriveNew'
import { translate } from '../../utils/useful'

export default class SingleFileToolbar extends Component {

    state = {}

    componentDidMount() {
        // console.log("componentDidMount !!!!!")
    }

    componentDidUpdate = (prevProps) => {
        // if (prevProps.data != this.props.data) { }
    }

    openSelectAppletModal = () => {
        this.selectApplet.appletViewModal.open()
    }

    render() {
        return (
            <div className='w-100 flexc '>

                <button onClick={() => this.props.downloadFile()} ref={el => this.framesNode = el} className='flexc mrd-1'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-hover'>
                        <div className='flexcc mrd-2'>
                            <img className={!this.props.colors?.iconInvert ? 'invert' : ''} width={16} src="/assets/icons/useful/cloud-download.svg" alt='' />
                        </div>
                        <p className='font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Download')}</p>
                    </div>
                </button>


                <button onClick={() => {}} ref={el => this.framesNode = el} className='flexc mrd-1'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-hover'>
                        <div className='flexcc mrd-2'>
                            <img className={!this.props.colors?.iconInvert ? 'invert' : ''} width={16} src="/assets/icons/useful/print.svg" alt='' />
                        </div>
                        <p className='font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Print')}</p>
                    </div>
                </button>



                <button onClick={() => {}} ref={el => this.framesNode = el} className='flexc mrd-1'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-hover'>
                        <div className='flexcc mrd-2'>
                            <img className={!this.props.colors?.iconInvert ? 'invert' : ''} width={16} src="/assets/icons/useful/share-square.svg" alt='' />
                        </div>
                        <p className='font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('Share')}</p>
                    </div>
                </button>


                <button onClick={() => {}} ref={el => this.framesNode = el} className='flexc mrd-1'>
                    <div className='flexcc pld-3 prd-4 py-1 br-5 dark-blur-hover'>
                        <div className='flexcc mrd-2'>
                            <img className={!this.props.colors?.iconInvert ? 'invert' : ''} width={16} src="/assets/icons/useful/circle-ellipsis-vertical.svg" alt='' />
                        </div>
                        <p className='font-size-14 text-semibold' style={{ color: this.props.colors?.textColor ?? '#fff' }}>{translate('More')}</p>
                    </div>
                </button>

            </div>
        )
    }
}
